import { Button, Typography } from "@mui/material";
import { useExportCandidateAttachments } from "../../Queries/CandidateQueries";
import { useCurrentUser } from "../../Queries/UserQueries";
import { useDebouncedHandler } from "../../State/Hooks/useDebouncedHandler";
import Modal from "../Modal/Modal";

export const ExportAttachmentsModal = ({
  isOpen,
  handleCloseModal,
  onExportAttachmentsClick,
}: {
  isOpen: boolean;
  handleCloseModal: () => void;
  onExportAttachmentsClick: () => void;
}) => {
  const { email } = useCurrentUser();
  const { isLoading } = useExportCandidateAttachments();
  const handleExportAttachments = useDebouncedHandler(onExportAttachmentsClick, 300);
  return (
    <Modal
      isOpen={isOpen}
      handleCloseModal={handleCloseModal}
      dataTestId="export-candidate-attachments"
      title="Export Candidate Attachments"
      content={
        <Typography>
          The export process for candidate attachments can take some time. Once the export is complete, you
          will receive an email at <strong>{email}</strong> with a download link.
        </Typography>
      }
      footerContent={
        <>
          <Button data-test="close-export-attachments" onClick={handleCloseModal} color="primary">
            Close
          </Button>
          <Button
            data-test="confirm-export-attachments"
            disabled={isLoading}
            onClick={handleExportAttachments}
            color="primary"
            variant="contained"
          >
            Start Export
          </Button>
        </>
      }
    />
  );
};
